import { Component, Input, OnInit } from '@angular/core';
import { Control, ControlType } from '../../models/controls/control';
import { SelectControl } from '../../models/controls/select-control';
import { RadioControl } from '../../models/controls/radio-control';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss'],
})
export class FormControlComponent implements OnInit {
  @Input()
  control: Control<any> = new Control<string>('', '', ControlType.text);

  @Input()
  form?: NgForm;

  select = ControlType.select;
  radio = ControlType.radio;
  email = ControlType.email;
  password = ControlType.password;
  date = ControlType.date;
  checkbox = ControlType.checkbox;
  age = ControlType.age;
  ahv = ControlType.ahv;
  phone = ControlType.phone;

  constructor() {}

  ngOnInit(): void {}

  getControlAsRadio(): RadioControl {
    return this.control as RadioControl;
  }

  getControlAsSelect(): SelectControl {
    return this.control as SelectControl;
  }
}
